// extracted by mini-css-extract-plugin
module.exports =  {"close-button":"_2787e5dfdf--close-button--zbMLd"};